import { useState } from "react"
import { t } from "@lingui/core/macro"
import {
    BroadcastStatus,
    PrivateRequestStatus,
    StreamStatus,
} from "@multimediallc/web-utils"
import { selectStreamStatus } from "../../../store/broadcastSlice"
import { useAppSelector } from "../../../store/hooks"
import { selectRoomPrivateRequestStatus } from "../../../store/roomSlice"
import { ConfirmModal } from "../../common/molecules/ConfirmModal"
import { declineOrEndPrivateShow } from "../api"
import { BroadcastRoomSubject } from "../BroadcastRoomSubject"
import { MobileBroadcastChat } from "../MobileBroadcastChat"
import { useMobileBroadcastContext } from "../mobileBroadcastContext"
import { MuteUnmuteButton } from "../MuteUnmuteButton"
import { PrivateShowAcceptDenyModal } from "../PrivateShowAcceptDenyModal"
import { RecordButton } from "../RecordButton"
import { ReturnFromAwayUI } from "../ReturnFromAwayUI"
import { RoomStatusAndFPS } from "../RoomStatusAndFPS"
import { TokenCount } from "../TokenCount"
import "./MobileBroadcastLandscapeUI.scss"

export const MobileBroadcastLandscapeUI = () => {
    const [showEndPrivateConfirm, setShowEndPrivateConfirm] = useState(false)
    const privateShowRequestStatus = useAppSelector(
        selectRoomPrivateRequestStatus,
    )
    const { broadcastStatus } = useMobileBroadcastContext()
    const streamStatus = useAppSelector(selectStreamStatus)

    return (
        <div
            className="MobileBroadcastLandscapeUI"
            data-testid="mobilebroadcast-landscape-ui"
        >
            <div className="MobileBroadcastLandscapeUI__LeftSection">
                <div className="MobileBroadcastLandscapeUI__LeftSection__Top">
                    <RoomStatusAndFPS />
                </div>
                <div className="MobileBroadcastLandscapeUI__LeftSection__Bottom">
                    <MobileBroadcastChat />
                </div>
            </div>
            <div className="MobileBroadcastLandscapeUI__RightSection">
                <div className="MobileBroadcastLandscapeUI__RightSection__Top">
                    <BroadcastRoomSubject />
                    <TokenCount />
                    {privateShowRequestStatus &&
                        privateShowRequestStatus.status ===
                            PrivateRequestStatus.requested && (
                            <PrivateShowAcceptDenyModal />
                        )}
                </div>
                <div className="MobileBroadcastLandscapeUI__RightSection__Bottom">
                    <RecordButton
                        onEndPrivateShowRequest={() =>
                            setShowEndPrivateConfirm(true)
                        }
                    />
                    <MuteUnmuteButton />
                </div>
            </div>

            {broadcastStatus !== BroadcastStatus.Offline &&
                streamStatus === StreamStatus.Away && (
                    <div className="MobileBroadcastLandscapeUI__ReturnFromAwayWrapper">
                        <ReturnFromAwayUI />
                    </div>
                )}

            <ConfirmModal
                isOpen={showEndPrivateConfirm}
                onClose={() => {
                    setShowEndPrivateConfirm(false)
                }}
                onConfirm={() => {
                    declineOrEndPrivateShow()
                    setShowEndPrivateConfirm(false)
                }}
                title={t`End Private Show?`}
                message={t`Are you sure you want to end your private show?`}
                confirmText={t`End Show`}
                cancelText={t`Cancel`}
            />
        </div>
    )
}
